'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var locale = {
    placeholder: '请选择时间'
};
exports["default"] = locale;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.8.1@antd/lib/time-picker/locale/zh_CN.js
// module id = 971
// module chunks = 0